/** Preço R$/kWh no tratamento canônico do detalhe por tipo — 19px semibold
 * royal + "/kWh" 12px (Tarifa no Sheet Map-First.html). Usado no peek da
 * home, no rodapé do sheet expandido e no detalhe por tipo. */
export function TariffPrice({
  tariff,
  className = ''
}: {
  tariff: string;
  className?: string;
}) {
  return (
    <div className={`flex items-baseline gap-1.5 ${className}`}>
      <span className="text-[19px] font-semibold tracking-tight text-bow-royal">
        R$ {Number(tariff).toFixed(2).replace('.', ',')}
      </span>
      <span className="text-[12px] text-bow-royal/55">/kWh</span>
    </div>
  );
}
